import React from "react";
import "./cta.sass";
const CTA = ({ cta }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "tint-cta" }, /* @__PURE__ */ React.createElement("a", { href: cta.url, target: "_blank", rel: "noopener noreferrer" }, cta.text));
};
export default CTA;
